export default "__VITE_PUBLIC_ASSET__1fe42dfc__"